<template>
  <div v-loading="loading" element-loading-text="正在执行" style="padding: 20px">
    <div style="margin-bottom:20px">
      <select-area @areaListId="getAreaListId" :clear="clear" :multiple-status="true" />
      <el-input
          v-model="query.orderId"
          placeholder="订单Id"
          style="width: 180px;margin-right: 10px"
          class="mr10"
      ></el-input>
      <el-input
          v-model="query.studentName"
          placeholder="学生姓名"
          style="width: 180px;margin-right: 10px"
          class="mr10"
      ></el-input>
      <el-input
          v-model="query.coachName"
          placeholder="操作教练姓名"
          style="width: 180px;margin-right: 10px"
          class="mr10"
      ></el-input>
      <el-date-picker
          style="width: 260px;margin-right: 10px"
          v-model="v2"
          type="daterange"
          range-separator="至"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          format="YYYY-MM-DD"
          value-format="YYYY-MM-DD"
      >
      </el-date-picker>
      <el-button
          type="primary"
          icon="Search"
          style="margin-left: 10px"
          @click="handleSearch"
      >搜索
      </el-button>

      <el-popconfirm @confirm="exportExcel" title="确定要导出吗？">
        <template #reference>
          <el-button type="primary" icon="Download"
          >导出
          </el-button
          >
        </template>
      </el-popconfirm>
    </div>
    <el-table style="overflow-x: auto !important;"
              v-loading="tableLoading"
              :data="tableData"
              border
              class="table el-table__cell"
              ref="multipleTable"
              :row-style="{ height: 57 + 'px' }"
              :cell-style="{ padding: 0 + 'px' }"
              height="610px"
              header-cell-class-name="table-header"
              @selection-change="handleSelectionChange"
    >
      <el-table-column
          fixed
          show-overflow-tooltip="true"
          prop="studentName"
          label="学生姓名"
          width="100"
      />

      <el-table-column
          width="120"
          show-overflow-tooltip="true"
          align="center"
          label="主卡ID"
          prop="orderId"
      />
      <el-table-column width="120" label="所属城市">
        <template #default="scope">{{ scope.row.cityName }}</template>
      </el-table-column>
      <el-table-column

          show-overflow-tooltip="true"
          label="校区"
      >
        <template #default="scope"
        >{{ scope.row.campusName }}
        </template>
      </el-table-column>
      <el-table-column width="110" label="卡片金额">
        <template #default="scope">{{
            scope.row.cardMoney
          }}
        </template>
      </el-table-column>
      <el-table-column width="110" prop="oldUsedMoney" label="操作教练">
        <template #default="scope">
          <div>{{ scope.row.updateName }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="oldData"
                       show-overflow-tooltip="true"
                       label="修改前"/>
      <el-table-column prop="newData"
                       show-overflow-tooltip="true"
                       label="修改后"/>
      <el-table-column prop="alterContent"
                       show-overflow-tooltip="true"
                       label="修改内容"/>
      <el-table-column prop="description"
                       width="200"
                       show-overflow-tooltip="true"
                       label="备注"/>
      <el-table-column
          prop="createTime"
          label="添加时间"
      />
    </el-table>
    <div class="pagination">
      <el-pagination
          background
          layout="total, prev, pager, next"
          :current-page="query.pageIndex"
          :page-size="query.pageSize"
          :total="pageTotal"
          @current-change="handlePageChange"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import {exportLoadBatchDisOrder, loadBatchDisOrder} from '@/api/order'
import selectArea from "../../../components/SelectArea";

export default {
  components: {
    selectArea,
  },
  data() {
    return {
      tableLoading: false,
      v2: [],
      loading: false,
      query: {
        campusIds: [],
        pageIndex: 1,
        pageSize: 10,
        endTime: "",
        coachName: '',
        orderId: null,
        startTime: "",
        studentName: ""
      },
      tableData: [],
      pageTotal: 0
    }
  },
  created() {
    this.getDataList()
  },
  methods: {
    //处理行 选中
    handleSelectionChange(val){
      console.log("row点击",val)
    },
    //加载数据
    getDataList() {
      if (this.campusType == 1) {
        // console.log(123);
      }
      this.tableLoading = true
      loadBatchDisOrder(this.query).then(res => {
        // console.log(res);
        if (res.code == 200) {
          this.tableData = res.data.records;
          this.pageTotal = res.data.total;
          this.tableLoading = false
        } else {
          this.$message.error("获取表格数据失败");
          this.tableLoading = false
        }
      })
    },
    //导出excel
    exportExcel() {
      exportLoadBatchDisOrder(this.query)
    },
    //组件传回的区域ID集合
    getAreaListId(val) {
      console.log(val);
      this.query.campusIds = val;
    },
    //执行搜索
    handleSearch() {
      // console.log(this.v2);
      if (this.v2.length >= 2) {
        this.query.startTime = this.v2[0];
        this.query.endTime = this.v2[1];
      }
      this.query.pageIndex = 1;
      this.getDataList();
    },
    //点击分页
    handlePageChange(val) {
      this.query.pageIndex = val;
      this.getDataList();
    },
  }
}
</script>
<style>

</style>
